import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.image-marquee__splide' ).length ) {
        $( '.image-marquee__splide' ).each( function( index, element ) {
          let lightboxTrigger;
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            perPage: 1,
            gap: '18px',
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );

          $( element ).magnificPopup( {
            delegate: '.image-marquee__lightbox-trigger',
            type: 'image',
            mainClass: 'image-marquee__lightbox',
            closeOnContentClick: false,
            closeBtnInside: false,
            fixedContentPos: true,
            autoFocusLast: false,
            callbacks: {
              beforeOpen: function() {
                lightboxTrigger = this.st.el?.[0];
              },
              open: function() {
                slider.Components.AutoScroll.pause();
              },
              close: function() {
                slider.Components.AutoScroll.play();
              },
              afterClose: function() {
                lightboxTrigger?.focus( {preventScroll: true} );
              },
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-marquee', COMPONENT );
} )( app );
